import { DatePicker, Form, FormItemProps } from 'antd';
import { DatePickerProps } from 'antd/lib';
import { RangePickerProps } from 'antd/es/date-picker';

interface DatePickerFormProps {
  datePickerProps?: DatePickerProps;
  format?: string;
  formProps?: FormItemProps;
  isRangePicker?: boolean;
  rangePickerProps?: RangePickerProps;
}

export const DatePickerForm = ({
  datePickerProps,
  formProps,
  isRangePicker,
  rangePickerProps,
}: DatePickerFormProps) => (
  <Form.Item 
    {...formProps}
    hasFeedback={formProps?.hasFeedback !== undefined ? formProps.hasFeedback : true}
  >
    {isRangePicker ? (
      <DatePicker.RangePicker
        className='w-100'
        {...rangePickerProps}
        format={rangePickerProps?.format ?? 'DD/MM/YYYY'}
      />
    ) : (
      <DatePicker
        className='w-100'
        {...datePickerProps}
        format={datePickerProps?.format ?? 'DD/MM/YYYY'}
        placeholder={datePickerProps?.placeholder ?? 'dd/mm/yyyy'}
      />
    )}
  </Form.Item>
);
